import { render, staticRenderFns } from "./ScoringCriterionFormWrapper.vue?vue&type=template&id=15b1665d&scoped=true&"
import script from "./ScoringCriterionFormWrapper.vue?vue&type=script&lang=js&"
export * from "./ScoringCriterionFormWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b1665d",
  null
  
)

export default component.exports